import { Button, Modal, Radio, Upload } from 'antd'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './StepModal.scss'
import { useDispatch, useSelector } from 'react-redux'
import JSZip from 'jszip'
import { UploadIcon } from 'assets/icons'
import { getPreplotPageAction, postFocusSourceFileListAction } from 'redux/reducers'
import { ProFormSelect } from '@ant-design/pro-form'
import { ProForm } from '@ant-design/pro-components'
import { getWKtList } from 'api'
import { getStroage, setStroage } from 'utils'
import { getPreplotDataSource } from 'pages/setting/ProjectDetails/Geometry/Preplot/PreplotTableHook'

export const StepModal = ({
    isModalVisibleCheck,
    setIsModalVisibleCheck,
    isFileLoading,
    UploadFileFinish,
    UploadSPSFileFinish,
    averageType,
    setAverageType,
    setIsFileLoading,
    projectId,
    calendarInfo,
    setFileList,
    setGeometryFile,
}) => {
    const { t } = useTranslation()
    const projectBaseData = useSelector(state => state.HeaderSlice.projectBaseData)
    const sourceType = projectBaseData?.data?.sourceType
    const isShowImportVp = sourceType?.includes('vibrator')
    const [files, setFiles] = useState([])
    const [filesName, setFilesName] = useState([])
    const [VpFiles, setVpFiles] = useState([])
    const [VpFilesName, setVpFilesName] = useState([])
    const [coordinateList, setCoordinateList] = useState()
    const dispatch = useDispatch()
    const formRef = useRef()
    const hasSetInitial = useRef(false)
    const coordinateSystem = getStroage('coordinateSystem')
    const paginatedData = useSelector(state => state.PreplotSlice.paginatedData)
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)

    /* 获取分页数据 */
    const getPaginationData = num => {
        const params = {
            pageNum: 1,
            pageSize: 9999,
            projectId: userInfo?.user?.projectId,
        }
        dispatch(getPreplotPageAction(params)) // 发送请求
    }

    const dataSource = getPreplotDataSource(paginatedData)

    /* 初始化 */
    useLayoutEffect(() => {
        getPaginationData() // 请求分页数据
        getWKtList()
            .then(res => {
                setCoordinateList(res?.data?.data)
            })
            .catch(err => {})
    }, [])

    useEffect(() => {
        if (dataSource?.[0] && Object.keys(dataSource[0]).length === 0) return
        if (!hasSetInitial.current) {
            formRef.current.setFieldsValue({
                coordinateSystem: coordinateSystem ? coordinateSystem : dataSource?.[0]?.coordinateSystem, // 手动赋值
            })
            setGeometryFile(coordinateSystem ? coordinateSystem : dataSource?.[0]?.coordinateSystem)
            hasSetInitial.current = true
        }
    }, [dataSource])

    return (
        <Modal
            closable={false}
            maskClosable={false}
            title={t('Vibrator.import')}
            visible={isModalVisibleCheck}
            destroyOnClose={true}
            forceRender={true}
            width={600}
            wrapClassName='StepImportModal'
            onOk={async () => {}}
            footer={[
                <Button
                    key='cancel'
                    onClick={() => {
                        setAverageType('production')
                        setFiles([])
                        setFilesName([])
                        setVpFiles([])
                        setVpFilesName([])
                        setIsModalVisibleCheck(false)
                    }}
                >
                    {t('common.cancel')}
                </Button>,
                <Button
                    key='confirm'
                    type='primary'
                    loading={isFileLoading} // 按钮加载状态
                    onClick={async () => {
                        setIsFileLoading(true)
                        const fileListParams = {
                            produceDate: calendarInfo,
                            projectId,
                        }
                        await files?.reduce(async (prevPromise, item) => {
                            // 等待前一个任务完成
                            await prevPromise
                            // 执行当前任务
                            return UploadSPSFileFinish(item?.fileData, item?.fileName)
                        }, Promise.resolve())
                        await VpFiles?.reduce(async (prevPromise, item) => {
                            // 等待前一个任务完成
                            await prevPromise
                            // 执行当前任务
                            return UploadFileFinish(item?.fileData, item?.fileName)
                        }, Promise.resolve())
                        await dispatch(postFocusSourceFileListAction(fileListParams)).then(res => {
                            setFileList(res?.payload?.data?.data)
                        })
                        setIsFileLoading(false)
                        setFiles([])
                        setFilesName([])
                        setVpFiles([])
                        setVpFilesName([])
                        setIsModalVisibleCheck(false)
                    }}
                >
                    {t('common.OK')}
                </Button>,
            ]}
        >
            <div className='content-wrapper'>
                <div className='step-container'>
                    <div className='step'>{t('Vibrator.chooseType')}</div>
                    <div className='radioStep'>
                        <Radio.Group
                            onChange={e => {
                                setAverageType(e.target.value)
                            }}
                            value={averageType}
                            options={[
                                { label: t('Vibrator.production'), value: 'production' },
                                { label: t('Vibrator.activityShots'), value: 'test' },
                            ]}
                            className='averageType'
                        />
                    </div>
                </div>

                <div className='step-container'>
                    <div className='step'>{t('Vibrator.chooseTypeSPS')}</div>
                    <div className='radioStep'>
                        <span className='import'>
                            <Upload
                                beforeUpload={file => {
                                    setFilesName(prev => [...prev, file.name])
                                    const zip = new JSZip()
                                    zip.file(file.name, file)
                                        .generateAsync({
                                            type: 'blob',
                                            compression: 'DEFLATE',
                                            compressionOptions: {
                                                level: 6,
                                            },
                                        })
                                        .then(content => {
                                            // const fileData = new File([content], `${file.name}.zip`, {
                                            //     type: 'application/zip',
                                            // })
                                            files.push({ fileData: file, fileName: file.name })
                                            setFiles(files)
                                        })
                                    return false
                                }}
                                maxCount={5}
                                key='upload'
                                // accept='.txt'
                                multiple={true}
                            >
                                <Button icon={<UploadIcon />} className={`upload ${filesName ? 'uploaded' : ''}`}>
                                    {filesName?.map((item, index) => {
                                        return <span className={index !== 0 ? 'filesName' : 'fileName'}>{item}</span>
                                    })}
                                </Button>
                            </Upload>
                        </span>
                    </div>
                </div>
                <div className='step-container'>
                    <div className='step'>{t('Vibrator.geometry')}</div>
                    <div className='radioStep'>
                        <ProForm formRef={formRef} submitter={false}>
                            <ProFormSelect
                                name='coordinateSystem'
                                initialValue={dataSource?.[0]?.coordinateSystem}
                                fieldProps={{
                                    options: coordinateList?.map(item => ({ label: item.wkt, value: item.code })),
                                    showSearch: true,
                                    allowClear: false,
                                    onChange: (value, option) => {
                                        // 1. 保存选中值（value）到 localStorage
                                        setStroage('coordinateSystem', value)
                                        setGeometryFile(value)
                                    },
                                }}
                            />
                        </ProForm>
                    </div>
                </div>
                {isShowImportVp && (
                    <div className='step-container'>
                        <div className='step'>{t('Vibrator.chooseTypeVp')}</div>
                        <div className='radioStep'>
                            <span className='import'>
                                <Upload
                                    beforeUpload={file => {
                                        setVpFilesName(prev => [...prev, file.name])
                                        const zip = new JSZip()
                                        zip.file(file.name, file)
                                            .generateAsync({
                                                type: 'blob',
                                                compression: 'DEFLATE',
                                                compressionOptions: {
                                                    level: 6,
                                                },
                                            })
                                            .then(content => {
                                                // const fileData = new File([content], `${file.name}.zip`, {
                                                //     type: 'application/zip',
                                                // })
                                                VpFiles.push({ fileData: file, fileName: file.name })
                                                setVpFiles(VpFiles)
                                            })
                                        return false
                                    }}
                                    maxCount={5}
                                    key='upload'
                                    accept='.txt'
                                    multiple={true}
                                >
                                    <Button icon={<UploadIcon />} className={`upload ${VpFilesName ? 'uploaded' : ''}`}>
                                        {VpFilesName?.map((item, index) => {
                                            return (
                                                <span className={index !== 0 ? 'filesName' : 'fileName'}>{item}</span>
                                            )
                                        })}
                                    </Button>
                                </Upload>
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    )
}
